import { useAuth } from '../providers/AuthContext';
import { LeftNav } from '../layouts/Base';
import { Outlet } from 'react-router-dom';
import {
    ADMIN_SETUP_STEPS,
    DATA_MANAGER_HOME,
    DATA_MANAGER_WORKSPACE_LABEL,
} from '../constants/setupRoadmapSteps';

function Admin() {
    const { user, girderInfo } = useAuth();

    if (!user || !user.admin) {
        return (
            <div><h2>Please log in as an administrator to view this page</h2></div>
        );
    }

    const isConfigured = girderInfo && girderInfo !== 'pending' && typeof girderInfo === 'object' && girderInfo.isConfigured === true;

    const setupRoadmapChildren = ADMIN_SETUP_STEPS.map((step) => ({
        text: step.title,
        to: step.route,
        disabled: !isConfigured,
    }));

    const navLinks = [
        { text: 'Home', to: '/', disabled: false },
        { text: 'Setup Roadmap', to: '/admin/setup', disabled: false, children: setupRoadmapChildren },
        { text: 'Users', to: '/admin/users', disabled: !isConfigured },
        { text: 'Test', to: '/admin/test', disabled: !isConfigured },
        { text: DATA_MANAGER_WORKSPACE_LABEL, to: DATA_MANAGER_HOME, disabled: !isConfigured },
        { text: 'Projects', to: '/projects', disabled: !isConfigured },
    ];

    return (
        <>
        <LeftNav navLinks={navLinks}>
            <Outlet/>
        </LeftNav>
        </>
    )
}

export default Admin;
